import React, { useEffect, useState, useRef } from 'react';
import anime from 'animejs';
import cancelIcon from '../../../../assets/images/close-icon.svg';
import './CreateNewProjectGroup.scss';
import Input from '../../../../components/Input';

const CreateNewProjectGroup = ({ handleClosePopup, handleSavePG }) => {
  const [groupName, setGroupName] = useState('');
  const [isGroupCreated, setIsGroupCreated] = useState(false);

  const deactivatePopup = useRef(null);

  const changePGName = (e) => {
    const value = e.target.value;
    const sanitizedValue = value.replace(/[&\/\\#,+()$~%.'":*?<>{}!¡]/g, '');
    setGroupName(sanitizedValue);
  };

  const collapsePopup = () => {
    setGroupName('');

    if (deactivatePopup.current) {
      anime({
        targets: deactivatePopup.current,
        height: 0,
        easing: 'easeInOutCubic',
        duration: 200,
        complete: closePopup,
      });
    } else {
      closePopup();
    }
  };

  const closePopup = () => {
    if (handleClosePopup) {
      handleClosePopup();
    }
    setIsGroupCreated(false);
  };

  const handleSave = () => {
    if (handleSavePG && groupName.length > 0) {
      handleSavePG(groupName);
    }
    setIsGroupCreated(true);
  };

  return (
    <div className="project-group-name-popout-background">
      <div className="project-group-name-popout" ref={deactivatePopup}>
        <header className="project-group-name-popout__header" style={{ backgroundColor: '#184E78' }}>
          <div className="caption" style={{ color: 'white' }}>
            Set Project Group Name
          </div>
          <div className='close-button'>
            <img
              src={cancelIcon}
              alt="cancel"
              className='close-button'
              onClick={collapsePopup}
            />
          </div>
        </header>

        <section className='project-group-name-popout__container'>
          {!isGroupCreated ? <Input
            className='project-group-name-input'
            name='fileName'
            value={groupName}
            placeholder={'Enter a project group name'}
            onChange={changePGName}
            pattern="[A-Za-z0-9_-]{1,15}"
          /> :
          <p className='success-text'>Project group {groupName} has been created and this project has been added to it!</p>
          }
        </section>

        {!isGroupCreated ? (
          <div className='project-group-name-popout__button-container'>
            <button className='cancel-button' onClick={collapsePopup}>
              CANCEL
            </button>

            <button
              className='save-button'
              style={{
                backgroundColor: groupName.length > 0 ? '#27ae60' : 'gray',
                border: groupName.length > 0 ? '#5DB348' : 'gray',
              }}
              onClick={groupName.length > 0 ? handleSave : null}
            >
              SAVE
            </button>
          </div>
        ) : (
          <div className='project-group-name-popout__button-container'>
            <button className='save-button' style={{ right: '25px' }} onClick={collapsePopup}>OK</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateNewProjectGroup;



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectCRUD/CreateNewProjectGroup/index.js